/*
 * @Autor: Nehc
 * @Date: 2020-11-27 10:38:20
 * @LastEditors: Nehc
 * @LastEditTime: 2020-11-27 10:51:33
 */
import Form from './form.vue';

export default Form;
